import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { SiteColors } from '@/types/site';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateCssVariables(colors: SiteColors) {
  const {
    text,
    background,
    foreground,
    card,
    cardForeground,
    popover,
    popoverForeground,
    primary,
    primaryForeground,
    secondary,
    secondaryForeground,
    muted,
    mutedForeground,
    accent,
    accentForeground,
    destructive,
    border,
    input,
    ring,
  } = colors;

  return `
:root {
  --txt: ${text || '#111827'};
  
  --background: ${background || 'oklch(1 0 0)'};
  --foreground: ${foreground || 'oklch(0.145 0 0)'};

  --card: ${card || 'oklch(1 0 0)'};
  --card-foreground: ${cardForeground || 'oklch(0.145 0 0)'};

  --popover: ${popover || 'oklch(1 0 0)'};
  --popover-foreground: ${popoverForeground || 'oklch(0.145 0 0)'};

  --primary: ${primary || 'oklch(0.205 0 0)'};
  --primary-foreground: ${primaryForeground || 'oklch(0.985 0 0)'};

  --secondary: ${secondary || 'oklch(0.97 0 0)'};
  --secondary-foreground: ${secondaryForeground || 'oklch(0.205 0 0)'};

  --muted: ${muted || 'oklch(0.97 0 0)'};
  --muted-foreground: ${mutedForeground || 'oklch(0.556 0 0)'};

  --accent: ${accent || 'oklch(0.97 0 0)'};
  --accent-foreground: ${accentForeground || 'oklch(0.205 0 0)'};

  --destructive: ${destructive || 'oklch(0.577 0.245 27.325)'};

  --border: ${border || 'oklch(0.922 0 0)'};
  --input: ${input || 'oklch(0.922 0 0)'};
  --ring: ${ring || 'oklch(0.708 0 0)'};
}
`.trim();
}
